import { Button } from '@mui/material';
import { Input } from 'components/SignInput';
import { Routes } from 'constants/pages';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { validateEmail } from 'services/helpers/user';
import { useSignIn } from '../hooks';

interface FormValues {
  email: string;
  password: string;
}

export const SignInForm: React.FC = () => {
  const { register, handleSubmit, formState, setError, setFocus } = useForm<FormValues>({
    mode: 'onTouched',
  });
  const signIn = useSignIn<FormValues>();

  const onSubmit = handleSubmit(async (values) => {
    try {
      await signIn(values);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      if (e.non_field_errors) {
        // incorrect email
        if (e.non_field_errors.includes('no_account')) {
          setError('email', { type: 'value', message: 'Email is not valid.' });
        }
        // incorrect password
        if (e.non_field_errors.includes('invalid_password')) {
          setError('password', {
            type: 'value',
            message: 'Password is not valid.',
          });
        }
        // deactivated
        if (e.non_field_errors.includes('deactivated')) {
          setError('email', { type: 'value', message: 'This email has been deactivated.' });
        }
      }
    }
  });

  const validate = (email: string) => {
    if (validateEmail(email)) {
      return true;
    }
    setFocus('email');
    return 'Email is not valid.';
  };

  const disableSubmit =
    !formState.dirtyFields.email ||
    !formState.dirtyFields.password ||
    !!formState.errors.email ||
    !!formState.errors.password;

  return (
    <form onSubmit={onSubmit} className="w-[500px] max-w-[90vw] space-y-8">
      <div className="flex flex-col space-y-4 text-left">
        <Input
          label="Email*"
          type="email"
          id="email"
          placeholder="work@email.com"
          inputProps={register('email', {
            required: true,
            validate,
          })}
          autoFocus
          error={formState.errors.email}
        />
        <Input
          label="Password*"
          type="password"
          id="password"
          placeholder="password"
          inputProps={register('password', { required: true })}
          error={formState.errors.password}
        />
      </div>
      <div className="space-y-4">
        <Button
          id="submit-sign-in"
          type="submit"
          size="large"
          variant="contained"
          fullWidth
          disabled={disableSubmit}
        >
          <h3>Continue</h3>
        </Button>
        <Link to={Routes.ResetPassword} className="block text-blue-900 underline">
          Reset your password
        </Link>
        <Link to={Routes.SignUp} className="block text-blue-900 underline">
          Create new account instead
        </Link>
      </div>
    </form>
  );
};
SignInForm.displayName = 'Pages.SignIn.Form';
